"use strict";
export const migration10 = (state) => {
  if (!state?.user?.recentConnectionMeta) {
    return state;
  }
  delete state.user.recentConnectionMeta;
  return { ...state, _persist: { ...state._persist, version: 10 } };
};
